import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const useWorkspaceMembers = (workspaceMembers) => {
    const [members, setMembers] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchMembers = async () => {
            try {
                setLoading(true);
                const memberPromises = Object.entries(workspaceMembers).map(async ([uid, memberData]) => {
                    const userDoc = await getDoc(doc(db, 'users', uid));
                    return [uid, { ...memberData, ...userDoc.data() }];
                });

                const memberDetails = Object.fromEntries(await Promise.all(memberPromises));
                setMembers(memberDetails);
            } catch (err) {
                console.error('Error fetching members:', err);
                setError('Failed to load members');
            } finally {
                setLoading(false);
            }
        };

        fetchMembers();
    }, [workspaceMembers]);

    return { members, loading, error };
};